module.exports = __webpack_public_path__ + "img/sales-orders-multi.8c6c69c3.svg";